<div class="content dark">
	<div *ngIf="users === undefined" class="loader">
		<div class="logo-spin" [class.light]="light"></div>
		Calculating...
	</div>
	<table *ngIf="users" style="width: 100%">
		<tr>
			<th></th>
			<th colspan="3" style="text-align: center; background-color: #666">Logins over last:</th>
		</tr>
		<tr>
			<th>User</th>
			<th><a (click)="SortBy('day')" href="javascript:void(0)">Day</a></th>
			<th><a (click)="SortBy('month')" href="javascript:void(0)">Month</a></th>
			<th><a (click)="SortBy('semi')" href="javascript:void(0)">6 Months</a></th>
		</tr>
		<tr *ngFor="let user of users">
			<td>{{user.email}}</td>
			<td>{{user.day}}</td>
			<td>{{user.month}}</td>
			<td>{{user.semi}}</td>
		</tr>
	</table>
</div>